<template>
  <div class="informWrapper">
    <!-- <div
      class="informTrigger"
      @click.stop="showInformDialog"
      v-tooltip="{trigger:'manual', show: isShowTooltip,content:'你已举报成功，小乐正在处理中'}"
    >举报</div>-->
    <!-- 弹出框 -->
    <div class="informDialog_out">
      <div class="informDialog_inner" @click.stop="stopBubble">
        <div class="title">
          <span>请选择你想要举报的类型</span>
          <span @click="hiddeInformDialog">
            <img src="../../assets/img/closeInform.png" alt />
          </span>
        </div>
        <div class="content">
          <span
            v-for="(item,index) in informData"
            :key="item"
            @click="toggleClass(index)"
            :class="{chosenColor:activeInformIndex===index}"
          >{{item}}</span>
          <div class="contentArea" v-if="activeInformIndex===informData.length-1">
            <textarea name="inform" placeholder="请输入" v-model="textAreaVal"></textarea>
          </div>
        </div>
        <div class="button">
          <span
            @click="confirmInform"
            :class="(this.textAreaVal===''&&this.activeInformIndex===5 )|| (this.activeInformIndex === -1)?'unClick':''"
          >确定</span>
          <span @click="cancleInform">取消</span>
        </div>
      </div>
    </div>
    <!-- 提示弹框 -->
    <div class></div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import axios from "axios";
import qs from "qs";
import { getQueryStringByName } from "../../assets/js/utils"

export default {
  name: "inform",
  data() {
    return {
      // isShowInformDialog: true, // 是否展示举报
      informData: [
        "垃圾广告",
        "内容抄袭",
        "人身攻击",
        "有害信息",
        "违法信息",
        "其他"
      ],
      activeInformIndex: -1,
      textAreaVal: "",
      isClickInform: false, // 防止重复点击
      isShowTooltip: false // 是否展示tooltip
    };
  },
  props: {
    id: {
      type: Number // 文章或者评论id
    },
    toId: {
      type: Number // 发表这篇文章或者评论人的id
    },
    type: {
      type: String // 当前是文章还是评论
    }
  },
  methods: {
    showInformDialog() {
      let checkData = {};
      checkData[`${this.type}_id`] = this.id;
      checkData[`auth_cookie`] = parseInt(getQueryStringByName("auth_cookie"));
      axios({
        method: "post",
        url: "/wapi/expose/check",
        data: checkData
      }).then(res => {
        if (!res.data.data.expose_check) {
          this.activeInformIndex = -1;
          this.textAreaVal = "";
          this.isShowInformDialog = true;
        } else {
          this.isShowTooltip = true;
          setTimeout(() => {
            this.isShowTooltip = false;
          }, 1000);
        }
      });
    },
    hiddeInformDialog() {
      this.$emit("closeInformDialog");
    },
    stopBubble() {},
    toggleClass(index) {
      console.log(index);
      this.activeInformIndex = index;
    },
    confirmInform() {
      if (this.isClickInform) return;
      this.isClickInform = true;
      let requestData = {
        to_uid: this.toId, // 当前文章发表或者评论者的id this.toId
        report_type: this.activeInformIndex + 1,
        report_text: this.textAreaVal,
        auth_cookie: parseInt(getQueryStringByName("auth_cookie"))
      };
      if (this.type === "at") {
        requestData["at_id"] = this.id;
      } else {
        requestData["ac_id"] = this.id;
      }
      axios({
        method: "post",
        url: "/wapi/expose",
        data: requestData
      }).then(res => {
        this.$emit("closeInformDialog");
        this.isClickInform = false;
        // }
      });
    },
    cancleInform() {
      this.$emit("closeInformDialog");
    }
  },
  computed: {
    ...mapState(["user"])
  },
  mounted() {
    console.log("user+++", this.user.uid);
  }
};
</script>

<style lang="scss" scoped>
@import "_a/scss/variable.scss";
.informWrapper {
  display: inline-block;
  margin-left: 20px;
  .informTrigger {
    cursor: pointer;
    color: #999999;
    font-size: 14px;
  }
  .informDialog_out {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    z-index: 9999999;
    .informDialog_inner {
      position: fixed;
      top: calc(50% - 151px);
      left: calc(50% - 200px);
      width: 400px;
      min-height: 302px;
      background: rgba(255, 255, 255, 255);
      border-radius: 10px;
      color: #000;
      display: flex;
      flex-direction: column;
      .title {
        display: flex;
        justify-content: space-between;
        margin: 19px 30px;
        span:nth-child(1) {
          width: 176px;
          height: 22px;
          font-size: 16px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          line-height: 22px;
        }
        span:nth-child(2) {
          width: 12px;
          height: 12px;
          cursor: pointer;
          img {
            width: 12px;
            height: 12px;
          }
        }
      }
      .content {
        margin: 20px 30px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        flex: 1;
        span {
          display: inline-block;
          width: 100px;
          height: 40px;
          background: rgba(255, 255, 255, 1);
          border-radius: 20px;
          border: 1px solid rgba(229, 229, 229, 1);
          font-size: 14px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: rgba(102, 102, 102, 1);
          line-height: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 20px;
          cursor: default;
        }
        .contentArea {
          width: 340px;
          height: 80px;
          textarea {
            width: 100%;
            height: 100%;
            width: 340px;
            background: rgba(248, 248, 248, 1);
            border-radius: 4px;
            border: 1px solid rgba(229, 229, 229, 1);
          }
        }
      }
      .button {
        width: 100%;
        height: 60px;
        border-top: 1px solid rgba(229, 229, 229, 1);
        span {
          width: 49%;
          height: 100%;
          font-size: 16px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          line-height: 22px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          &:nth-child(1) {
            color: rgba(255, 122, 50, 1);
            border-right: 1px solid rgba(229, 229, 229, 1);
          }
          &:nth-child(2) {
            color: #666666;
          }
        }
        .unClick {
          opacity: 0.5;
          pointer-events: none;
        }
      }
    }
  }
  // 选中颜色
  .chosenColor {
    color: #ff7a32 !important;
    border-color: #ff7a32 !important;
  }
}
</style>